import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import * as service from '../../services/service';

function CaseStageDetails() {
    const [state, setState] = useState({
        hearingtime: '', remarks: ''
    });
    const [caseData, setCaseData] = useState([]);
    const [data, setData] = useState([]);
    const [hearingDate, setHearingDate] = useState(new Date());
    const [caseStageData, setCaseStageData] = useState([]);
    const [caseStageId, setCaseStageId] = useState('');    
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };    
    const params = useParams();
    const navigate = useNavigate();
    // const userLvl = JSON.parse(sessionStorage.getItem('userData')).userLevel;

    const getCaseStages = (id) => {        
        fetch(
            service.GET_CASE_STAGE_BY_TYPE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseTypeId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.caseStageId, label: item.caseStage }));
                setCaseStageData(data2);
            });
    };

    const getCaseDetailsById = () => {        
        setLoading(true);        
        fetch(
            service.GET_CASE_DETAILS_BY_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseId: params.id,
                })
            })
            .then(res => res.json())
            .then(result => {               
                setCaseData(result);                
                getCaseStages(result.caseTypeId);
                
            });
        setLoading(false);
    };

   
    const getDetails = () => {
        const errs = {};
        fetch(
            service.GET_CASE_STAGE_DETAILS_BY_CASE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseId: params.id,
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        fetch(
            service.GET_CASE_STAGE_DETAILS_BY_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    DetailId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.message.messageType === 'Success') {
                    setState({
                        ...state, hearingtime: result.hearingTime, remarks: result.remarks
                    });

                    const stgData = ({ value: result.caseStageId, label: result.caseStage });
                    setCaseStageId(stgData);
                    setHearingDate(new Date(result.hearingDate));
                }
                else {
                    errs[".invalid"] = result.message.message;
                    setErrors(errs);
                }
            });
        setLoading(false);
    };

    const handleEdit = (id) => {
        getDetailsById(id);
        localStorage.setItem("ID", JSON.stringify(id));
    }

    useEffect(() => {
        setLoading(true);
        getCaseDetailsById();
        getDetails();
        // getCaseStages();
        setLoading(false);
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!hearingDate) {
            isValid = false;
            errs[".hearingDate"] = "Please select Hearing Date";
        }
        if (!state.hearingtime) {
            isValid = false;
            errs[".hearingtime"] = "Please enter Hearing Time";
        }
        if (!caseStageId) {
            isValid = false;
            errs[".caseStageId"] = "Please select Case Stage";
        }

        setErrors(errs);
        return isValid;
    }

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const CaseStageChangeHandler = (ev) => {
        setCaseStageId(ev);
    }
    const backHandler = () => {
        navigate(`/work/casedetails`);
    }

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_CASE_STAGE_DETAILS,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        DetailId: JSON.parse(localStorage.getItem('ID')) !== null ? JSON.parse(localStorage.getItem('ID')) : 0,
                        CaseId: params.id,
                        CaseStageId: caseStageId.value,
                        HearingDate: moment(hearingDate).format("MM/DD/YYYY"),
                        HearingTime: state.hearingtime,
                        Remarks: state.remarks,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        localStorage.setItem('ID', null);
                        // window.location.reload();
                        setState({ ...state, hearingtime: '', remarks: '' });
                        getDetails();
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Case Stage Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell width="45%" style={{fontSize: '14px'}}>                                            
                                                Civil IDC : {caseData ? caseData.civilIDC : ''}
                                            </TableCell>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Civil CEO : {caseData ? caseData.civilCEO : ''}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Civil SEO : {caseData ? caseData.civilSEO : ""}
                                            </TableCell>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Civil Division : {caseData ?  caseData.civilDivision : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Court : {caseData ?  caseData.court : ''}
                                            </TableCell>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Case Type : {caseData ? caseData.caseType : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Case No : {caseData ?  caseData.caseNo : ''}
                                            </TableCell>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Notice No : {caseData ? caseData.noticeNo : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Notice Date : {caseData ? moment(caseData.noticeDate).format('DD/MM/YYYY') : ""}
                                            </TableCell>
                                            <TableCell style={{fontSize: '14px'}}>
                                                Project : {caseData ? caseData.project : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                Hearing Date
                                                <DatePicker
                                                    id="hearingDate"
                                                    selected={hearingDate}
                                                    onChange={date => setHearingDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    tabIndex={0}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".hearingDate"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Hearing Time" fullWidth value={state.hearingtime || ''}
                                                    name="hearingtime"
                                                    onChange={changeHandler}
                                                    id="hearingtime"
                                                    required
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".hearingtime"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Case Stage"
                                                    options={caseStageData} placeholder="Select Case Stage"
                                                    value={caseStageId}
                                                    onChange={CaseStageChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseStageId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Remarks" fullWidth value={state.remarks || ''}
                                                    name="remarks"
                                                    onChange={changeHandler}
                                                    id="remarks"
                                                    required
                                                    multiline
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".remarks"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={backHandler}>
                                                Back
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>

                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">

                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Hearing Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Hearing Time</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Case Stage</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>                                                
                                                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.detailId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{moment(row.hearingDate).format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell>{row.hearingTime}</TableCell>
                                                        <TableCell>{row.caseStage}</TableCell>
                                                        <TableCell>{row.remarks}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.caseId)}>Edit</MDButton></TableCell>                                                        
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default CaseStageDetails;